import React from "react";

import Clock from "assets/icons/clock.svg";
import Close from "assets/icons/close.svg";
import styles from "./SearchHistoryItem.module.scss";

type Props = {
  name: string;
  onClick: () => void;
  onRemove: () => void;
};

const SearchHistoryItem: React.FC<Props> = props => {
  const { name, onClick, onRemove } = props;

  const handleOnRemove = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    e.stopPropagation();
    onRemove();
  };

  return (
    <div className={styles.searchHistoryItem} onClick={onClick}>
      <Clock className={styles.searchHistoryItemClock} />
      <div className={styles.searchHistoryItemContainer}>
        <span className={styles.searchHistoryItemName}>{name}</span>
        <Close
          className={styles.searchHistoryItemClose}
          onClick={handleOnRemove}
        />
      </div>
    </div>
  );
};

export default SearchHistoryItem;
